import React,{useState} from 'react'
import AdminLayout from '../AdminLayout';
import ContentHeader from '../layout/ContentHeader';
import Gstr1 from './Gstr1';
import ReportNav from './ReportNav';
import Gstr3b from './Gstr3b';
import Tds from './Tds';
import Invoice from './Invoice';
import Product from './Product';

export default function Report() {
     const [activeTab, setActiveTab] = useState('gstr1');
     

     const handleTabChange = (tab) => {
          setActiveTab(tab);
     };
     const renderContent = () => {
          switch (activeTab) {
               case 'gstr1':
                    return <Gstr1 />;
               case 'gstr3b':
                    return <Gstr3b />;
               case 'tds':
                    return <Tds />;
               case 'invoice':
                    return <Invoice />;
               case 'product':
                    return <Product />;
               default:
                    return null;
          }
     };

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="reports" />

                    <div className="col-lg-12 mb-2">
                         <ReportNav onTabChange={handleTabChange} />
                    </div>
                    <div className="col-lg-12 ">
                         <div>{renderContent()}</div>
                    </div>
               </div>
          </AdminLayout>
     )
}
